module.exports = __webpack_public_path__ + "img/four.8f30cd54.jpg";